module.exports = __webpack_public_path__ + "static/img/gpt53.c4983438.png";